/**
 * Created by Dong on 2017/7/27.
 */
/**
 * END_SESSION action
 * Used to end the session with a customer
 */
import api from '../../utils/api'
import * as types from '../../constants/ActionTypes'

let startSessionByPicc = (requestId, waitTime, currentAgent) => {
    var url = '/lossAss/serviceRequests/next'

    return dispatch => {
        dispatch(startSessionInitiate(requestId))
        return api(url)
            .put({ id: requestId, agentId: currentAgent._id })
            .then(serviceRequest => {
                // 视频接通后 刷新工单详情

                window.postMessage({ security: true, eventName: 'updateReport' }, '*')
                if (serviceRequest.errCode == 0) {
                    return dispatch(startSessionFinish(serviceRequest, waitTime, currentAgent))
                } else {
                    return dispatch(startSessionFailed(requestId))
                }


            })
            .catch(err => {
                return dispatch(startSessionFailed(requestId))
            })
    }
}
let startSessionInitiate = (requestId) => {
    return {
        type: types.START_SESSION,
        payload: { requestId }
    }
}

let startSessionFailed = (requestId) => {
    return {
        type: types.START_SESSION_FINISH,
        payload: { requestId: requestId },
        error: true
    }
}

/**
 * START_SESSION_FINISH action
 * Dispatched when fetching the service request is finished
 * @params {Object} serviceRequest - next service request in queue
 */
let startSessionFinish = (serviceRequest, waitTime, currentAgent) => {
    // let trackData = {
    // 	'userterminal': serviceRequest.result.userInfo.terminalChannel,
    // 	'userchannel': serviceRequest.result.channelType,
    // 	'userprovince': serviceRequest.result.userInfo.province,
    // 	'usercity': serviceRequest.result.userInfo.city,
    // 	'userlongitude': serviceRequest.result.userInfo.longitude,
    // 	'userlatitude': serviceRequest.result.userInfo.latitude,
    // 	'agentname': currentAgent.fullName,
    // 	'reportid': serviceRequest.result.userInfo.reportId,
    // 	'carnumber': serviceRequest.result.userInfo.carNumber,
    // 	'reporter': serviceRequest.result.userInfo.phone ? serviceRequest.result.userInfo.phone : '',
    // 	'username': serviceRequest.result.userInfo.name ? serviceRequest.result.userInfo.name : ''
    // };
    // MtaH5.clickStat('start_session', trackData);
    // console.log("坐席接起 埋点: ", trackData);
    return {
        type: types.START_SESSION_FINISH,
        payload: {
            serviceRequest: serviceRequest.result,
            requestId: serviceRequest.result._id,
            waitTime,
            currentAgentNumber: currentAgent.loginName,
            currentAgentName: currentAgent.fullName
        }
    }
}
let endSessionByPicc = (serviceRequestId) => {
    return (dispatch, getState) => {
        let url = '/serviceRequests/endSession'

        if (serviceRequestId) {
            api(url)
                .post({ id: serviceRequestId })
                .then(serviceRequest => {
                    dispatch(endSessionFinish(serviceRequestId))
                    dispatch(endCall(serviceRequest))
                })
                .catch(err => {

                    dispatch(endSessionFinish(serviceRequestId))
                })
        }
    }
}

let endSessionFinish = (serviceRequestId) => {
    return {
        type: types.END_SESSION_LOSSASS,
        payload: { serviceRequestId }
    }
}

let endCall = (serviceRequest) => {
    if (serviceRequest.errCode == 0) {
        return {
            type: 'END_CALL',
            payload: serviceRequest.result
        }
    }
}

let getCallOnTime = (requestId) => {
    let url = '/lossAss/serviceRequests/getCallOnTime'
    return dispatch => {
        api(url).post({ id: requestId })
            .then(result => {
                // 视频接通后 刷新工单详情

                window.postMessage({ security: true, eventName: 'updateReport' }, '*')

            })
            .catch(err => {

            })
    }
}


export default {
    endSessionByPicc,
    startSessionByPicc,
    getCallOnTime
}
